import React, { useEffect, useState } from 'react'

import classNames from 'classnames'
import { Button, Input } from 'shared/components'
import { useQuery } from 'shared/hooks'
import { getProjects } from 'store/action-creators/catalog'

import { CatalogFilters } from '../Filters/Filters'
import { getProjectsParams } from '../utils'
import classes from './MobileFilters.module.scss'

type Props = {
  isOpen: boolean
  setIsOpen: () => void
  setIsMore: (m: boolean) => void
}

export const MobileFilters: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  setIsMore,
}): JSX.Element => {
  // const [isOpen, setIsOpen] = useState(false)
  const [query, setQuery] = useQuery()
  const [localQuery, setLocalQuery] = useState({ ...query })
  const [count, setCount] = useState<number | null>(null)

  const cn = classNames([classes.dialog], { [classes.visible]: isOpen })

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
    setLocalQuery(query)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  useEffect(() => {
    getProjects(getProjectsParams(localQuery))
      .then(v => setCount(v?.data?.count || 0))
      .catch(() => setCount(0))
  }, [localQuery])

  const handleClick = () => {
    const q = Object.keys(localQuery).length ? { ...localQuery, page: '1' } : {}
    setQuery(q)
    setIsOpen()
  }

  const changeQuery = (path: string, value: string) => {
    setLocalQuery({ ...localQuery, [path]: value })
  }

  return (
    <div className={cn}>
      <div className={classes.header}>
        Фильтры
        <Button
          size="small"
          btnType="secondary_light"
          onClick={() => setIsOpen()}
        >
          Отменить
        </Button>
      </div>
      <Input
        icon="icon-search"
        value={localQuery?.filmName || ''}
        onChange={e => changeQuery('filmName', e.target.value)}
        onClear={() => changeQuery('filmName', '')}
        placeholder="Поиск по названию"
      />
      <CatalogFilters
        useLocalQuery
        localQuery={localQuery}
        setLocalQuery={q => setLocalQuery(q)}
        setIsMore={setIsMore}
      />
      <div className={classes.flatBtn_wrap}>
        <Button
          className={classes.flatBtn}
          size="medium"
          full
          onClick={handleClick}
        >
          Показать {count !== null ? `(${count})` : ''}
        </Button>
      </div>
    </div>
  )
}
